import axios from 'api';

export const getFileManagerData = async (params) => {
  return axios.get(`api/file_manager/file_manager/?search=${params.search}&page=${params.pageIndex}&page_size=${params.pageSize}`);
};

export const deleteFileManagerData = async (params) => {
  let result = {};
  try {
    const res = await axios.delete(`api/file_manager/file_manager/${params.id}`, params);
    result = res.data || {};
    return { success: true, data: result };
  } catch (error) {
    return {
      success: false,
      message: error || 'something went wrong'
    };
  }
};
